export const makeElementDraggable = (
  targetElement: HTMLElement | null,
  elementToDrag: HTMLElement | null
) => {
  if (targetElement === null || elementToDrag === null) {
    return {
      registerDrag: () => {},
      unRegisterDrag: () => {},
    } as const;
  }

  let isDragging = false;

  targetElement.addEventListener('mousedown', () => {
    isDragging = true;
  });

  const dragElement = (event: MouseEvent) => {
    if (!isDragging) {
      return;
    }

    const deltaX = window.innerWidth - event.pageX;

    // Ограничение перемещения по горизонтали
    if (deltaX >= 0 && deltaX <= window.innerWidth - targetElement.offsetWidth) {
      elementToDrag.style.right = `${deltaX}px`;
    }
  };

  const stopDragging = () => {
    isDragging = false;
  };

  return {
    registerDrag: () => {
      document.addEventListener('mousemove', dragElement);
      document.addEventListener('mouseup', stopDragging);
      targetElement.addEventListener('click', stopDragging);
    },
    unRegisterDrag: () => {
      document.removeEventListener('mousemove', dragElement);
      document.removeEventListener('mouseup', stopDragging);
      targetElement.removeEventListener('click', stopDragging);
    },
  } as const;
};
